import SocietesController from './societes.controller';

export default {
    template: require('./societes.tpl.html'),
    controller: SocietesController
};
